import { CountryUserConfig } from "@domain/localization/country";

export type ProspectRequestReferential = Pick<CountryUserConfig, "postalCode" | "medicalProfessions">;

export type ProspectRequestReferentialsMap = Map<string, ProspectRequestReferential>;

export interface ProspectRequestConfig {
	supportedCountries: string[];
	initialCountryCode: string;
	referentialsMap: ProspectRequestReferentialsMap;
}

export enum ProspectCampaigns {
	DEMO_REQUEST = "demo-request",
	INVITE_YOUR_PT = "invite-your-pt",
}
